export default __webpack_public_path__ + "static/media/syringe-small.a9065f28.svg";